import $ from "cash-dom";

export const partnersComponent = async () => {
  const $button = $(".partners-button");
  const $menu = $(".partners-menu");

  $button.on("click", () => {
    const isOpen = $button.attr("aria-expanded") === "true";

    $menu.toggleClass("hidden flex");
    $button.attr("aria-expanded", String(!isOpen));
  });
};
